import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BbTableService, TableRow } from '../../../services/bb-table.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';

import { AbstractListComponent } from '../../shared/abstract-list.component';

@Component({
	selector: 'datafeed-list',
	templateUrl: './datafeed-list.component.html',
	styleUrls: ['./datafeed-list.component.scss'],
	providers: [BbTableService]
})

export class DatafeedListComponent extends AbstractListComponent implements OnInit, OnDestroy {
	subscriptions = new Subscription();
	putRight: boolean;
	filterConfig: BbFilterConfiguration;

	constructor(protected bbTableService: BbTableService) {

		super(bbTableService);

		this.listConfiguration = {
			name: 'datafeed',
			basePath: '/library/datafeed',
			activePath: '/library/datafeeds',
			entityTranslation: this.translate.instant('DATAFEED').toLowerCase(),
			entitiesTranslation: this.translate.instant('DATAFEEDS').toLowerCase()
		};
		// the presets are not being used yet in the html template
		this.filterConfig = {
			search: true,
			filters: [],
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('ACTIVE'),
				value: 'active',
				filterSet: [{
					filters: [{
						type: 'datafeed',
						field: 'status',
						operator: 'is',
						value: 'active'
					}]
				}],
			},
			{
				label: this.translate.instant('INACTIVE'),
				value: 'inactive',
				filterSet: [{
					filters: [{
						type: 'datafeed',
						field: 'status',
						operator: 'is',
						value: 'inactive'
					}]
				}],
			}]
		};
	}

	ngOnInit() {
		this.bbTableService
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();

		this.subscriptions.add(this.authenticationService.hasPermission('put').subscribe(putRight => {
			this.putRight = putRight;
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
		super.ngOnDestroy();
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['library/datafeed', row.data.id, 'metadata']);
		}
	}
}
